import 'react-native-url-polyfill/auto';
// Doit précéder createClient : installe crypto.subtle → supabase-js dérive le PKCE en S256 (et non plain).
import '../lib/pkcePolyfill';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Échouer tôt et clairement plutôt que de laisser des appels réseau muets.
  throw new Error(
    'Variables Supabase manquantes : définir EXPO_PUBLIC_SUPABASE_URL et EXPO_PUBLIC_SUPABASE_ANON_KEY (.env).',
  );
}

/**
 * CLÉ DE STOCKAGE DE LA SESSION — IDENTIFIANT DE COMPATIBILITÉ. NE JAMAIS LA MODIFIER.
 *
 * Ce n'est pas un réglage : c'est la clé AsyncStorage sous laquelle vivent les sessions DÉJÀ
 * ENREGISTRÉES sur les téléphones installés. La changer déconnecte tout le monde à la mise à jour,
 * sans message et sans recours — l'application ne trouve plus rien à l'ancienne adresse et se croit
 * face à une première ouverture.
 *
 * Jusqu'ici elle n'était pas écrite : supabase-js la DÉRIVE de l'URL, très exactement en
 * `sb-${new URL(supabaseUrl).hostname.split('.')[0]}-auth-token` (SupabaseClient, v2.107.0). Avec
 * `https://swwksuskwuhqzozofbno.supabase.co`, cela donnait la chaîne ci-dessous.
 *
 * ELLE EST FIGÉE ICI PARCE QUE L'URL CHANGE. Le passage au domaine personnalisé
 * `https://auth.alternjob.com` ferait dériver `sb-auth-auth-token` — une valeur différente, et au
 * passage générique : le premier segment est « auth », qui ne désigne plus aucun projet.
 *
 * `swwksuskwuhqzozofbno` reste donc dans ce fichier À DEMEURE, comme trace de l'origine des
 * sessions. Ce n'est pas une URL, ce n'est pas une configuration, et cela ne se « nettoie » pas en
 * même temps que le reste.
 */
const SESSION_STORAGE_KEY = 'sb-swwksuskwuhqzozofbno-auth-token';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: AsyncStorage,
    storageKey: SESSION_STORAGE_KEY,
    autoRefreshToken: true,
    persistSession: true,
    // Natif : pas de session dans l'URL. PKCE requis pour exchangeCodeForSession (OAuth Google).
    // N'affecte pas signInWithPassword (grant_type=password, hors flux redirect).
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
});
